<template>
    <div class="exception" :class="{ 'mobile-exception': mobile }">
        <div class="container">
            <img src="https://res.peki.vip/20230525/4e44478090264cf8852b4f8cb0333131.png" />

            <!-- 直播间结束 -->
            <div v-if="type == 1">
                <div class="description">
                    <van-icon class="warning" name="warning" />
                    <span class="text">
                        直播已结束，如非正常下播<br />
                        请等待老师重新进入
                    </span>
                </div>
                <div @click="onReload" class="btn">刷新重试</div>
            </div>

            <!-- 多设备登录错误 -->
            <div v-else-if="type == 2">
                <div class="description">
                    <van-icon class="warning" name="warning" />
                    <span class="text">该账号已在其他设备登录，您已下线</span>
                </div>
                <div @click="onReload" class="btn">刷新重试</div>
            </div>

            <!-- 其他异常错误 -->
            <div v-else-if="type">
                <div class="description">
                    <van-icon class="error" name="warning" />
                    <span class="text">{{ type }}</span>
                </div>
                <div @click="onReload" class="btn">刷新重试</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['mobile', 'type'],
    methods: {
        onReload() {
            window.location.reload()
        },
    },
}
</script>
<style lang="scss" scoped>
.exception {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 100;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 320px;
        img {
            width: 80%;
        }
    }
}
.description {
    margin-top: 16px;
    display: flex;
    align-items: center;
    .error,
    .warning {
        font-size: 24px;
        margin-right: 12px;
        color: #e6a23c;
    }
    .error {
        color: #f00;
    }
    .text {
        font-size: 16px;
        color: #333;
        text-align: center;
        line-height: 1.4em;
    }
}
.btn {
    width: fit-content;
    height: 42px;
    padding: 0 16px;
    background: #44cd94;
    cursor: pointer;
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    margin: 24px auto 0;
}

.mobile-exception {
    .container {
        max-width: 10000px;
        width: 100%;
        img {
            width: 100px;
        }
    }

    .description {
        width: 200px;
        margin-top: 8px;
        justify-content: center;
        .error,
        .warning {
            font-size: 18px;
            margin-right: 6px;
        }
        .text {
            font-size: 14px;
            line-height: 1.2em;
        }
    }

    .btn {
        width: fit-content;
        height: 24px;
        padding: 0;
        color: #44cd94;
        background: none;
        font-size: 14px;
        font-weight: 600;
        margin: 12px auto 0;
    }
}
</style>
